<template>
  <div>
    <div class="stepsController">
      <div
        @click="clickTap"
        v-for="(val, ind) in list"
        :key="ind"
        class="aTap"
        :style="list.length - 1 === ind ? 'flex: unset;' : ''"
        :class="[
          val.act
            ? list[ind + 1] && list[ind + 1].act
              ? 'aTapAct'
              : 'aTapActLast'
            : '',
          val.error ? 'aTapActLastRed' : ''
        ]"
      >
        <div class="yuan">{{ ind + 1 }}</div>
        <div class="text">
          <div>{{ val.name }}</div>
          <div v-if="val.msg">{{ val.msg }}</div>
        </div>
        <div class="line" v-if="list.length - 1 !== ind"></div>
      </div>
      <div v-if="fanhui" @click="back" class="back">
        <div v-if="!showTool">返回上级</div>
        <el-tooltip
          v-else
          :manual="true"
          :value="true"
          class="qipao"
          effect="dark"
          content="请返回到未审核通过的页面，修改后重新提交"
          placement="top"
        >
          <div>返回上级</div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 是否显示气泡
    showTool: {
      default: false
    },
    fanhui: {
      default: true
    },
    list: {
      default: function() {
        return [
          {
            name: "步骤",
            act: true,
            url: "a"
          },
          {
            name: "步骤",
            act: true,
            url: "a"
          },
          {
            name: "步骤",
            act: false,
            url: "a"
          }
        ];
      },
      type: Array
    }
  },
  methods: {
    back() {
      this.$emit("back");
    },
    clickTap(val) {
      this.$emit("change", val);
    }
  }
};
</script>
<style lang="less" scoped>
.stepsController {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
  opacity: 1;
  display: flex;
  align-items: center;
  padding: 20px 47px;
  .aTap {
    transition: all 0.2s;
    flex: 1;
    display: flex;
    align-items: center;
    cursor: pointer;
    .yuan {
      transition: all 0.2s;
      text-align: center;
      line-height: 24px;
      width: 24px;
      height: 24px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: rgba(204, 204, 204, 1);
      border-radius: 50%;
      opacity: 1;
    }
    .text {
      transition: all 0.2s;
      margin-left: 13px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
      opacity: 1;
    }
    .line {
      transition: all 0.2s;
      margin-left: 20px;
      margin-right: 20px;
      flex: 1;
      height: 1px;
      background: rgba(204, 204, 204, 1);
      opacity: 1;
    }
  }
  .aTap:last-child {
    flex: unset;
    .line {
      display: none;
    }
  }
  .aTapAct {
    flex: 1;
    display: flex;
    align-items: center;
    cursor: pointer;
    .yuan {
      border: 1px solid #0082a4;
      color: white;
      background-color: #0082a4;
    }
    .text {
      margin-left: 13px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #0082a4;
      opacity: 1;
    }
    .line {
      margin-left: 20px;
      margin-right: 20px;
      flex: 1;
      height: 1px;
      background: #0082a4;
      opacity: 1;
    }
  }
  // 选中
  .aTapActLast {
    flex: 1;
    display: flex;
    align-items: center;
    cursor: pointer;
    .yuan {
      border: 1px solid #0082a4;
      color: white;
      background-color: #0082a4;
    }
    .text {
      font-weight: bold !important;
      margin-left: 13px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #0082a4;
      opacity: 1;
    }
    .line {
      margin-left: 20px;
      margin-right: 20px;
      flex: 1;
      height: 1px;
      background: rgba(204, 204, 204, 1);
      opacity: 1;
    }
  }
  // 显示成红色
  .aTapActLastRed {
    flex: 1;
    display: flex;
    align-items: center;
    cursor: pointer;
    .yuan {
      border: 1px solid red;
      color: white;
      background-color: red;
    }
    .text {
      margin-left: 13px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: red;
      opacity: 1;
    }
    .line {
      margin-left: 20px;
      margin-right: 20px;
      flex: 1;
      height: 1px;
      background: red;
      opacity: 1;
    }
  }
  .back {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(0, 177, 255, 1);
    opacity: 1;
    margin-left: 61px;
    cursor: pointer;
  }
}
</style>
